import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { withRouter } from 'react-router-dom';
import { connect } from 'react-redux';
import { getItemFromRefList } from 'mt-react-common/modules/main/reducers/static/states/referenceLists/reducer';

class GroupByTypesSelect extends Component {
  constructor(props) {
    super(props);
    this.state = {
      value: this.getVerifiedPropStartValue()
    };
  }

  componentDidUpdate(prevProps, prevState) {
    if (this.state.value !== prevState.value) {
      this.props.handleChangeValue(this.state.value);
    }
  }

  getVerifiedPropStartValue = () => {
    const searchVal = this.props.userDaysStatGroupByTypes.find(
      i => i.value === this.props.startValue
    );
    if (searchVal) {
      return this.props.startValue;
    }
    return null;
  };

  getSelectValueTitle = () => {
    if (this.state.value === null) {
      return this.props.userDaysStatGroupByTypes[0].desc;
    }
    return this.props.userDaysStatGroupByTypes.find(
      i => i.value === this.state.value
    ).desc;
  };

  changeValue = async (event, newValue) => {
    event.preventDefault();
    this.setState({ value: newValue });
  };

  render() {
    return (
      <div className={this.props.className}>
        <button
          type="button"
          className="btn btn-default dropdown-toggle"
          data-toggle="dropdown"
          title={this.getSelectValueTitle()}
          aria-expanded="false"
        >
          <i className="fa fa-fw fa-calendar" /> {this.getSelectValueTitle()}
        </button>
        <ul className="dropdown-menu" role="menu">
          {this.props.userDaysStatGroupByTypes.map(item => (
            <li
              className={this.state.value === item.value ? 'active' : ''}
              key={`userDaysStatGroupByTypes${item.value}`}
            >
              <a href="" onClick={e => this.changeValue(e, item.value)}>
                {item.title}
              </a>
            </li>
          ))}
        </ul>
      </div>
    );
  }
}

GroupByTypesSelect.defaultProps = {
  className: 'form-group btn-group',
  startValue: null
};

GroupByTypesSelect.propTypes = {
  className: PropTypes.string,
  startValue: PropTypes.number,
  userDaysStatGroupByTypes: PropTypes.arrayOf(PropTypes.shape).isRequired,
  handleChangeValue: PropTypes.func.isRequired
};

const mapStateToProps = state => ({
  userDaysStatGroupByTypes: getItemFromRefList(
    state,
    'userDaysStatGroupByTypes'
  )
});

export default withRouter(connect(mapStateToProps)(GroupByTypesSelect));



// WEBPACK FOOTER //
// ./src/components/UserDaysStat/UserDaysStatTables/inputs/GroupByTypesSelect.js